<template>
    <div v-if="!loadingPage">
        <validation-observer ref="managementValidation" #default="{ invalid }">
            <b-form @submit.prevent>
                <div class="d-flex justify-content-between align-items-center">
                    <h3 class="text-primary mb-2">تنظیمات پایه</h3>
                    <div v-if="isAdminIdentityVerified" class="d-flex justify-content-end gap-3 mb-2">
                        <b-button type="submit" variant="primary" @click="validationForm" :disabled="invalid || loading"
                            class="d-flex gap-3">
                            ذخیره تغییرات
                            <b-spinner v-if="loading" variant="white" small></b-spinner>
                        </b-button>
                    </div>
                </div>
                <div v-if="isAdminIdentityVerified" class="pb-2">
                    <b-card>
                        <b-card-body class="row">
                            <div v-if="logoImage" class="col-12 mb-2">
                                <div class="d-flex justify-content-center justify-content-md-start">
                                    <div style="width: 90px;height: 90px;">
                                        <img :src="BASE_URL_File + logoImage"
                                            class="rounded-circle object-fit-cover border h-100 w-100">
                                    </div>
                                </div>
                            </div>

                            <!------------ name en ------------>
                            <b-form-group label="شناسه مجموعه" class="col-12 col-md-6 col-lg-4 mb-2">
                                <validation-provider #default="{ errors }" name="شناسه مجموعه"
                                    rules="store_Id|required">
                                    <b-form-input dir="rtl" v-model="form.Name_En" disabled class="text-primary-middle"
                                        :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!------------ name fa ------------>
                            <b-form-group label="نام مجموعه" class="col-12 col-md-6 col-lg-4 mb-2">
                                <b-form-input dir="rtl" v-model="form.Name_Fa" class="text-primary-middle" />
                            </b-form-group>

                            <!------------ Logo Image ------------>
                            <b-form-group label="لوگو" class="col-12 col-md-6 col-lg-4 mb-2">
                                <b-form-file ref="logoImage" browse-text="بارگذاری" @change="addLogo" placeholder="" />
                            </b-form-group>

                            <!------------ Avatar Image ------------>
                            <b-form-group label="تصویر پس زمینه پروفایل" class="col-12 col-md-6 col-lg-4 mb-2">
                                <b-form-file ref="avatarImage" browse-text="بارگذاری" @change="addAvatarImage"
                                    placeholder="" />
                            </b-form-group>

                            <!------------ Default Product Image ------------>
                            <b-form-group label="تصویر پیش‌فرض محصول" class="col-12 col-md-6 col-lg-4 mb-2">
                                <b-form-file ref="defaultProductImage" browse-text="بارگذاری"
                                    @change="addDefaultProductImage" placeholder="" />
                            </b-form-group>

                            <!------------ tagline ------------>
                            <b-form-group label="شعار" class="col-12 col-md-6 col-lg-4 mb-2">
                                <b-form-input dir="rtl" v-model="form.tagline" class="text-primary-middle" />
                            </b-form-group>

                            <!------------ phonenumber ------------>
                            <b-form-group label="شماره تماس" class="col-12 col-md-6 col-lg-4 mb-2">
                                <b-form-input inputmode="numeric" dir="ltr" v-model="form.PhoneNumber"
                                    class="text-primary-middle" />
                            </b-form-group>

                            <!------------ Instagram Id ------------>
                            <b-form-group label="آیدی اینستاگرام" class="col-12 col-md-6 col-lg-4 mb-2">
                                <b-form-input dir="ltr" v-model="form.InstagramId" class="text-primary-middle" />
                            </b-form-group>

                            <!------------ province ------------>
                            <b-form-group label="استان" class="col-12 col-md-6 col-lg-4 mb-2">
                                <v-select v-model="form.ProvinceId" dir="rtl" :options="provinces"
                                    :reduce="(val) => val.id" placeholder="انتخاب استان" label="name" :clearable="false"
                                    @input="onSelectProvince">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </b-form-group>

                            <!------------ city ------------>
                            <b-form-group v-if="form.ProvinceId" label="شهر *" class="col-12 col-md-6 col-lg-4 mb-2">
                                <validation-provider name="شهر *" rules="required">
                                    <v-select v-model="form.CityId" dir="rtl" :options="selectedCities(form.ProvinceId)"
                                        placeholder="انتخاب شهر" label="name" :reduce="(val) => val.id"
                                        :clearable="false">
                                        <template #no-options>
                                            موردی وجود ندارد
                                        </template>
                                    </v-select>
                                </validation-provider>
                            </b-form-group>


                            <!------------ geographicalLocation ------------>
                            <b-form-group label="عرض جغرافیایی" class="col-12 col-md-6 col-lg-4 mb-2">
                                <b-form-input dir="ltr" v-model="form.geographicalLocation.latitudes"
                                    class="text-primary-middle" />
                            </b-form-group>

                            <!------------ geographicalLocation ------------>
                            <b-form-group label="طول جغرافیایی" class="col-12 col-md-6 col-lg-4 mb-2">
                                <b-form-input dir="ltr" v-model="form.geographicalLocation.longitudes"
                                    class="text-primary-middle" />
                            </b-form-group>

                            <!------------ Show Rules Auto ------------>
                            <b-form-group label="نمایش خودکار قوانین" class="col-12 col-md-6 col-lg-4 mb-2">
                                <v-select v-model="form.showRulesAuto" :searchable="false" dir="rtl"
                                    :reduce="(value) => value.id" class="bg-white" style="border-radius: 6px;"
                                    label="name" :clearable="false" :options="showRulesAutoData">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </b-form-group>

                            <!------------ pager Is Active ------------>
                            <b-form-group label="درخواست‌ سالن‌دار" class="col-12 col-md-6 col-lg-4 mb-2">
                                <v-select v-model="form.pagerIsActive" :searchable="false" dir="rtl"
                                    :reduce="(value) => value.id" class="bg-white" style="border-radius: 6px;"
                                    label="name" :clearable="false" :options="waiterRequest">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </b-form-group>

                            <!------------ Calculating Tax Auto ------------>
                            <b-form-group label="محاسبه خودکار 10 درصد مالیات" class="col-12 col-md-6 col-lg-4 mb-2">
                                <v-select v-model="form.calculatingTaxAuto" :searchable="false" dir="rtl"
                                    :reduce="(value) => value.id" class="bg-white" style="border-radius: 6px;"
                                    label="name" :clearable="false" :options="calculatingTaxAutoData">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </b-form-group>

                            <!-- bankAccountCardNumber -->
                            <b-form-group label="شماره کارت" label-for="bankAccountCardNumber"
                                class="col-12 col-md-6 col-lg-4 mb-2">
                                <cleave id="bankAccountCardNumber" dir="ltr" v-model="form.bankAccountCardNumber"
                                    class="form-control text-center" :raw="false" :options="creditCard" />
                            </b-form-group>

                            <!-- bankAccountOwner -->
                            <b-form-group v-if="form.bankAccountCardNumber" label="نام صاحب حساب"
                                label-for="bankAccountOwnerId" class="col-12 col-md-6 col-lg-4 mb-2">
                                <validation-provider #default="{ errors }" name="نام صاحب حساب" rules="required">
                                    <b-form-input dir="rtl" id="bankAccountOwnerId" v-model="form.bankAccountOwner"
                                        name="bankAccountOwner" class="text-center user-select-none"
                                        :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <!------------ Order Mode ------------>
                            <b-form-group label="سفارش‌گیری" class="col-12 col-md-6 col-lg-4 mb-2">
                                <v-select v-model="form.orderMode" :searchable="false" dir="rtl"
                                    :reduce="(value) => value.id" class="bg-white" style="border-radius: 6px;"
                                    label="name" :clearable="false" :options="orderModeData">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </b-form-group>

                            <b-form-group v-if="subscriptionId == 3" label="حداقل مبلغ سفارش بیرون بر (ریال)"
                                class="col-12 col-md-6 col-lg-4 mb-2">
                                <cleave id="number" dir="ltr" v-model="form.outsideOrderMinimumPrice"
                                    class="form-control text-center" autocomplete="off" :raw="false"
                                    :options="amountSeparator" />
                            </b-form-group>

                            <b-form-group v-if="subscriptionId == 3" label="هزینه ارسال (ریال)"
                                class="col-12 col-md-6 col-lg-4 mb-2">
                                <cleave id="number" dir="ltr" v-model="form.courierFee" class="form-control text-center"
                                    autocomplete="off" :raw="false" :options="amountSeparator" />
                            </b-form-group>


                            <!------------ Loyalty System Mode ------------>
                            <b-form-group v-if="subscriptionId == 3" label="باشگاه مشتریان"
                                class="col-12 col-md-6 col-lg-4 mb-2">
                                <v-select v-model="form.loyaltySystemMode" :searchable="false" dir="rtl"
                                    :reduce="(value) => value.id" class="bg-white" style="border-radius: 6px;"
                                    label="name" :clearable="false" :options="loyaltySystemModeData">
                                    <template #no-options>
                                        موردی وجود ندارد
                                    </template>
                                </v-select>
                            </b-form-group>


                            <div class="col-12">
                                <div class="row">
                                    <!------------ Manual Ordering Message ------------>
                                    <b-form-group label="پیام حالت سفارش‌گیری سالن‌دار"
                                        class="col-12 col-md-6 col-lg-6 mb-2">
                                        <b-form-textarea dir="rtl" v-model="form.manualOrderingMessage"
                                            class="text-primary-middle" rows="3" no-resize />
                                    </b-form-group>

                                    <!------------ outside Ordering Message ------------>
                                    <b-form-group label="پیام حالت سفارش‌گیری بیرون بر"
                                        class="col-12 col-md-6 col-lg-6 mb-2">
                                        <b-form-textarea dir="rtl" v-model="form.outsideOrderingMessage"
                                            class="text-primary-middle" rows="3" no-resize />
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="row">
                                    <!------------ Address ------------>
                                    <b-form-group label="آدرس مجموعه" class="col-12 col-md-6 col-lg-6 mb-2">
                                        <b-form-textarea v-model="form.Address" dir="rtl" class="text-primary-middle"
                                            rows="3" no-resize />
                                    </b-form-group>

                                    <!------------ Description ------------>
                                    <b-form-group label="درباره مجموعه" class="col-12 col-md-6 col-lg-6 mb-2">
                                        <b-form-textarea v-model="form.Description" dir="rtl"
                                            class="text-primary-middle" rows="3" no-resize />
                                    </b-form-group>
                                </div>
                            </div>

                            <!------------ Rules ------------>
                            <b-form-group v-for="(item, index) in form.Rules" :key="`Rule${index}`"
                                :label="`قانون ${index + 1}`" class="col-12 col-md-4">
                                <validation-provider #default="{ errors }" :name="`قانون ${index + 1}`"
                                    rules="required">
                                    <div class="d-flex align-items-center">
                                        <b-form-input v-model="form.Rules[index]"
                                            :state="errors.length > 0 ? false : null"></b-form-input>
                                        <button @click="deleteRule(item)" class="pointer btn p-0 ml-75">
                                            <feather-icon icon="MinusCircleIcon" size="18" />
                                        </button>
                                    </div>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
                            <div class="col-12 mt-50">
                                <b-button :disabled="form.Rules.length > 5" @click="addRule" variant="outline-info">
                                    {{ form.Rules.length > 0 ? 'اضافه کردن قانون' : 'ایجاد قوانین مجموعه' }}
                                </b-button>
                            </div>

                        </b-card-body>
                    </b-card>
                </div>

            </b-form>
        </validation-observer>

        <b-card v-if="!isAdminIdentityVerified">
            <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                <span>برای دسترسی به این قسمت، لطفا</span>
                <router-link class="mx-25" to="/identity-management">هویت</router-link>
                <span>خود را تایید کنید.</span>
            </div>
        </b-card>

    </div>
</template>

<script>
import { BRow, BCol, BButton, BCard, BCardText, BAvatar, BForm, BFormRadioGroup, BFormTextarea, BFormGroup, BSpinner, BFormInput, BCardBody, BFormFile } from 'bootstrap-vue';
import vSelect from 'vue-select';
import Compressor from 'compressorjs';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, store_Id } from '@validations';
import { default as locations } from '@/@core/data/provinces';
import { storeService } from '@core/services';
import Cleave from 'vue-cleave-component';
import jwt_decode from "jwt-decode";


export default {
    components: {
        Cleave,
        BFormFile,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BCard,
        BCardText,
        BFormRadioGroup,
        BCardBody,
        BAvatar,
        BButton,
        BForm,
        BSpinner,
        ValidationProvider,
        ValidationObserver,
        BFormTextarea,
        vSelect,
    },
    data() {
        return {
            amountSeparator: {
                numeral: true,
                numeralThousandsGroupStyle: 'thousand',
            },
            store_Id,
            required,
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            loading: false,
            loadingPage: true,
            isAdminIdentityVerified: false,
            subscriptionId: null,
            form: {
                loyaltySystemMode: 0,
                CityId: null,
                email: null,
                ProvinceId: null,
                LogoImage: null,
                Name_Fa: null,
                Name_En: null,
                PhoneNumber: null,
                InstagramId: null,
                pagerIsActive: null,
                Description: null,
                geographicalLocation: {
                    latitudes: null,
                    longitudes: null
                },
                Address: null,
                RemoveCurrentLogoImage: false,
                Rules: [],
                tagline: null,
                showRulesAuto: false,
                orderMode: 0,
                manualOrderingMessage: null,
                outsideOrderingMessage: null,
                outsideOrderMinimumPrice: null,
                courierFee: null,
                bankKey: null,
                bankAccountCardNumber: null,
                bankAccountOwner: null,
                calculatingTaxAuto: false,
                avatarImage: null,
                RemoveCurrentAvatarImage: false,
                defaultProductImage: null,
                removeCurrentDefaultProductImage: false,
            },
            economicInfoAccepted: false,
            waiterRequest: [
                { name: 'غیرفعال', id: false },
                { name: 'فعال', id: true },
            ],
            calculatingTaxAutoData: [
                { name: 'غیرفعال', id: false },
                { name: 'فعال', id: true },
            ],
            orderModeData: [],
            loyaltySystemModeData: [
                { name: 'غیرفعال', id: 0 },
                { name: 'فعال (کش بک)', id: 2 },
                { name: 'فعال (امتیازدهی)', id: 3 },
                { name: 'فعال (کش بک و امتیازدهی)', id: 1 }
            ],
            showRulesAutoData: [
                { name: 'غیرفعال', id: false },
                { name: 'فعال', id: true },
            ],
            logoImage: null,
            avatarImage: null,
            defaultProductImage: null,
            storeId: null,
            provinces: [...locations],
            cities: null,
            banks: [],
            creditCard: {
                creditCard: true,
            },
        };
    },
    computed: {
        selectedCities() {
            return (id) => (id ? this.provinces.find((state) => state.id === id).cities : null);
        },
    },
    methods: {
        addLogo(event) {
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg" || event.target.files[0].type === "image/png") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            this.form.LogoImage = result
                        },
                    });

                }
                else {
                    this.$refs.logoImage.reset();
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                }
            }
            else {
                this.$refs.logoImage.reset();
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
            }
        },
        addAvatarImage(event) {
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            this.form.avatarImage = result
                        },
                    });

                }
                else {
                    this.$refs.avatarImage.reset();
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                }
            }
            else {
                this.$refs.avatarImage.reset();
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
            }
        },
        addDefaultProductImage(event) {
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg" || event.target.files[0].type === "image/png") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            this.form.defaultProductImage = result
                        },
                    });

                }
                else {
                    this.$refs.defaultProductImage.reset();
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                }
            }
            else {
                this.$refs.defaultProductImage.reset();
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
            }
        },
        validationForm() {
            this.$refs.managementValidation.validate().then((success) => {
                if (success) {
                    this.updateInfo();
                }
            });
        },
        updateInfo() {
            this.loading = true;
            this.logoImage ? this.form.RemoveCurrentLogoImage = false : this.form.RemoveCurrentLogoImage = true
            this.avatarImage ? this.form.RemoveCurrentAvatarImage = false : this.form.RemoveCurrentAvatarImage = true
            this.defaultProductImage ? this.form.removeCurrentDefaultProductImage = false : this.form.removeCurrentDefaultProductImage = true
            let formData = new FormData();
            formData.append("RemoveCurrentLogoImage", this.form.RemoveCurrentLogoImage)
            formData.append("RemoveCurrentAvatarImage", this.form.RemoveCurrentAvatarImage)
            formData.append("removeCurrentDefaultProductImage", this.form.removeCurrentDefaultProductImage)
            this.form.Name_Fa ? formData.append("Name_Fa", this.form.Name_Fa) : null
            this.form.manualOrderingMessage ? formData.append("manualOrderingMessage", this.form.manualOrderingMessage) : null
            this.form.outsideOrderingMessage ? formData.append("outsideOrderingMessage", this.form.outsideOrderingMessage) : null
            this.form.outsideOrderMinimumPrice ? this.form.outsideOrderMinimumPrice = Number(this.form.outsideOrderMinimumPrice.replace(/,/g, '')) : null
            this.form.outsideOrderMinimumPrice ? formData.append("outsideOrderMinimumPrice", this.form.outsideOrderMinimumPrice) : null
            this.form.courierFee ? this.form.courierFee = Number(this.form.courierFee.replace(/,/g, '')) : null
            this.form.courierFee ? formData.append("courierFee", this.form.courierFee) : null
            this.form.tagline ? formData.append("tagline", this.form.tagline) : null
            formData.append("pagerIsActive", this.form.pagerIsActive)
            formData.append("calculatingTaxAuto", this.form.calculatingTaxAuto)
            formData.append("orderMode", this.form.orderMode)
            formData.append("loyaltySystemMode", this.form.loyaltySystemMode)
            if (this.form.bankAccountCardNumber) {
                if (this.form.bankAccountCardNumber.length == 19) {
                    let cardNumberInput = null
                    cardNumberInput = this.form.bankAccountCardNumber.replace(/\s/g, '');
                    let cardNumber = cardNumberInput.slice(0, 6)
                    let bank = null
                    bank = this.banks.filter(bank => bank.identificationNumbers.includes(cardNumber))[0];
                    if (bank) {
                        this.form.bankKey = bank.key
                        formData.append("bankKey", this.form.bankKey)
                        formData.append("bankAccountOwner", this.form.bankAccountOwner)
                        formData.append("bankAccountCardNumber", cardNumberInput)
                    }
                }
            }
            formData.append("showRulesAuto", this.form.showRulesAuto)
            this.form.LogoImage ? formData.append("LogoImage", this.form.LogoImage, this.form.LogoImage.name) : null
            this.form.avatarImage ? formData.append("avatarImage", this.form.avatarImage, this.form.avatarImage.name) : null
            this.form.defaultProductImage ? formData.append("defaultProductImage", this.form.defaultProductImage, this.form.defaultProductImage.name) : null
            this.form.CityId ? formData.append("CityId", this.form.CityId) : null
            this.form.ProvinceId ? formData.append("ProvinceId", this.form.ProvinceId) : null
            this.form.Name_En ? formData.append("Name_En", this.form.Name_En) : null
            this.form.PhoneNumber ? formData.append("PhoneNumber", this.form.PhoneNumber) : null
            this.form.InstagramId ? formData.append("InstagramId", this.form.InstagramId) : null
            this.form.Description ? formData.append("Description", this.form.Description) : null
            this.form.Address ? formData.append("Address", this.form.Address) : null
            this.form.geographicalLocation.latitudes ? formData.append("geographicalLocation.Latitudes", this.form.geographicalLocation.latitudes) : null
            this.form.geographicalLocation.longitudes ? formData.append("geographicalLocation.Longitudes", this.form.geographicalLocation.longitudes) : null
            for (let index in this.form.Rules) {
                formData.append(`Rules[${index}]`, this.form.Rules[index]);
            }
            storeService.updateInfo(this.storeId, formData).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.getInfo();
            })
                .catch((err) => {
                    this.$notif({ type: 'error' });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getInfo() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                localStorage.setItem("urlName", data.urlName)
                this.orderModeData = []
                data.city ? this.form.CityId = data.city.id : null
                data.province ? this.form.ProvinceId = data.province.id : null
                this.form.Name_Fa = data.name_Fa
                this.form.manualOrderingMessage = data.manualOrderingMessage
                this.form.outsideOrderingMessage = data.outsideOrderingMessage
                this.form.outsideOrderMinimumPrice = data.outsideOrderMinimumPrice
                this.form.courierFee = data.courierFee
                this.form.bankAccountOwner = data.bankAccountOwner
                this.form.bankAccountCardNumber = data.bankAccountCardNumber
                this.form.bankKey = data.bankKey
                this.form.tagline = data.tagline
                this.form.pagerIsActive = data.pagerIsActive
                this.form.calculatingTaxAuto = data.calculatingTaxAuto
                this.form.orderMode = data.orderMode
                this.form.showRulesAuto = data.showRulesAuto
                this.form.Name_En = data.name_En
                this.form.PhoneNumber = data.phoneNumber
                this.form.InstagramId = data.instagramId
                this.form.Description = data.description
                this.form.loyaltySystemMode = data.loyaltySystemMode
                this.form.Address = data.address
                if (data.geographicalLocation) {
                    this.form.geographicalLocation.longitudes = data.geographicalLocation.longitudes
                    this.form.geographicalLocation.latitudes = data.geographicalLocation.latitudes
                }
                this.form.Rules = data.rules
                this.logoImage = data.logoImage
                this.avatarImage = data.avatarImage
                this.defaultProductImage = data.defaultProductImage
                this.economicInfoAccepted = data.economicInfoAccepted
                if (this.economicInfoAccepted) {
                    this.orderModeData.push(
                        { name: 'غیرفعال', id: 0 },
                        { name: 'توسط سالن‌دار', id: 1 },
                        { name: 'پرداخت آنلاین (داخل مجموعه)', id: 2 },
                        { name: 'پرداخت آنلاین ( بیرون بر)', id: 3 },
                        { name: 'پرداخت آنلاین (داخل مجموعه و بیرون بر)', id: 4 }

                    )
                }
                else {
                    this.orderModeData.push(
                        { name: 'غیرفعال', id: 0 },
                        { name: 'توسط سالن‌دار', id: 1 },

                    )
                }
                this.getBanks()
            })
        },
        async getBanks() {
            await this.$axios.get(`/store/banks`).then(({ data }) => {
                this.banks = data.items;
                this.loadingPage = false;
            })
        },
        onSelectProvince() {
            this.form.CityId = null;
        },
        addRule() {
            this.form.Rules.push(null)
        },
        deleteRule(value) {
            this.form.Rules = this.form.Rules.filter(item => item !== value)
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getInfo();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
    },
    mounted() {
        let accessToken;
        accessToken = localStorage.getItem("accessToken")
        const decodedJwt = jwt_decode(accessToken);
        this.subscriptionId = decodedJwt.current_subscription_id
        this.storeId = localStorage.getItem("storeId")
        this.getCompletionStatus()
    },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.gap-3 {
    gap: 8px;
}

.custom-file-label {
    padding-top: 9px;

    &::after {
        padding-top: 8px;
    }
}

.display-modes {
    width: 220px;
    box-shadow: #3a3333b9 0px 0px 8px;
    border: 2px solid #3a3333b9;

    &-active {
        box-shadow: #7367f0 0px 0px 25px;
        border: 2px solid #7367f0;
    }
}
</style>